/* ------------------------------------------ GRYFF COLOR PICKER - T 03.06.2017 ----------------------------------------- */
import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import { app } from '@/store';
import {
  dropPresetValueStyle,
  COLOR_KEYS_MAP,
  COLOR_KEYS_MAP_STYLE_NAME,
  COLOR_KEYS_MAP_ORDERED,
} from '@/modules/global-style';
import { DEFAULT_PRESET_CLASS, DEFAULT_COLOR_PACKS } from '@modules/editor-sidebar';
import throttle from '@/app/utils/throttle';
import store from '@/app/store/store';

(function (jQuery) {
  jQuery.gfColorPicker = function (element, options) {
    const defaults = {
      title: '',
      addHistory: true,
      onSelected: function (value, $el) {},
      onOpacity: function () {},
      offOpacity: function () {},
      onHistoryAdded: function () {},
    };

    const _dataValue = [];
    let _hide;

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    let _valueChanged = false;
    const _isTypingColor = false;
    let _isOnfocusInput = false;

    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();
    let preset = app.$store.getters['sidebar/getCurrentPresetInPage'];
    const generateGSColors = function () {
      let colors = {};
      if (preset) {
        const currentPresetColors = { ...DEFAULT_COLOR_PACKS[0], ...preset.presetOptions.colors[0].value };
        for (const colorType in currentPresetColors) {
          for (const color in Object(currentPresetColors)[colorType]) {
            const className = `${colorType}-${color}`;
            if (currentPresetColors[colorType][color]) {
              colors[className] = currentPresetColors[colorType][color];
            }
          }
        }
        colors = { ...COLOR_KEYS_MAP_ORDERED, ...colors };
      }

      return Object.fromEntries(Object.entries(colors).filter(([key, value]) => value));
    };

    let gsColors = generateGSColors();
    const gsColorsLength = Object.keys(gsColors).length;

    let _popup = '<div class="gfColorPickerPopup">';
    _popup += `<div class="popup">`;
    _popup += `<div id="tabs"><div><a id="tab1">Global Style</a></div><div><a id="tab2">Custom</a></div><div class="close-popup">${utils.svgIcon(
      'close',
    )}</div></div>`;
    _popup += `<div class="content-tab" id="tab1-content"><div class="gf_color-palette">`;
    _popup += `<div class="colors">`;
    if (gsColorsLength) {
      for (const color in gsColors) {
        const styleAlphaColor = `
          background: ${gsColors[color]};
          border: 1px solid ${
            window.tinycolor(gsColors[color]).isDark()
              ? window.tinycolor.mix(gsColors[color], 'white', 30).toHex8String()
              : window.tinycolor.mix(gsColors[color], 'black', 30).toHex8String()
          }
        `;
        _popup += `<div class="wrapper-item"><div class="item"><div class="alpha gs-color-alpha" data-color="${color}" style="${styleAlphaColor}"></div></div></div>`;
      }
    }
    _popup += '</div>';
    _popup += `<div class="gf_color-palette--footer"><span class="edit-styles">${
      gsColorsLength ? 'Edit styles' : 'Setup Global Style'
    }</span></div>`;
    _popup += '</div></div>';
    _popup += `<div class="content-tab" id="tab2-content"><div class="gfColorPickerText">`;
    _popup += `<div class="wrap-box"><div class="box"><span class="irrs-wrapper"><span class="gfColorPickerIris irrs"></span></span><input class="color-picker" type="hidden" data-alpha="true" placeholder="Color" /><input class="color-display" type="text" data-alpha="true" placeholder="Color" /></div>`;
    _popup += `<div class="clear icon-clear-color">${utils.svgIcon(
      'clear-circle',
    )}</div><div class="opacity"><input type=\"number\" max="100" min="0" class="gf_remove-spin-button" />%</div></div></div></div></div>`;
    _popup += '</div>';
    const $popup = jQuery(_popup);

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.setTemplate();

      $element.on('value-change', function () {
        _valueChanged = true;

        let value = $(this).val();
        value = HELPER.rgb2hex(value);
        if (!_hide) {
          const $gfColorPicker = $element.next('.gfColorPicker');
          const $inputPickerBody = $gfColorPicker.find('.gfColorPickerBody input.color-picker');
          $inputPickerBody.iris('color', value);
        }
        _this.setValue(value);

        _valueChanged = false;
      });
    };

    this.setTemplate = function () {
      let dataTitle;
      if (_this.settings.title == '') {
        dataTitle = 'none';
      } else {
        dataTitle = _this.settings.title;
      }
      const desc = typeof $element.attr('data-description') === 'undefined' ? '' : $element.attr('data-description');
      _hide = true;
      if ($element.attr('data-hide') && $element.attr('data-hide') == 'false') {
        _hide = false;
      }

      const alpha = typeof $element.attr('data-alpha') === 'undefined' ? '' : $element.attr('data-alpha');
      let value = typeof $element.attr('value') === 'undefined' ? '' : $element.attr('value');
      if (value == '') {
        const defaultVal = $element.attr('default_value');
        value = typeof defaultVal === 'undefined' || this.isValueGS(defaultVal) ? '' : defaultVal;
      }
      let _template = '<div class="gfColorPicker" data-title="' + dataTitle + '">';
      _template += '<div class="gfSGSubTitle">' + _this.settings.title + '</div>';
      _template += '<div class="gfSGclear"></div>';
      _template += '<div class="gfColorPickerBody">';
      _template += '<div class="box"><span class="irrs-wrapper"><span class="irrs"></span></span>';
      _template += '<input type="hidden" class="color-picker" data-alpha="' + alpha + '" placeholder="Color"/>';
      _template += '<input type="text" class="color-display" data-alpha="' + alpha + '" placeholder="Color"/></div>';
      _template += '<div class="color-action">';
      _template += '<div class="clear">' + utils.svgIcon('clear') + '</div>';
      _template +=
        '<div class="opacity">' + `<input type="number" max="100" min="0" class="gf_remove-spin-button" />%` + '</div>';
      _template += '</div>';
      _template += '<div class="box-action"><div class="unlink">' + utils.svgIcon('unlink') + '</div>';
      _template += '<div class="chevron_down icon-chevron_down">' + utils.svgIcon('chevron_down') + '</div></div>';
      _template += '</div>';
      _template += '<div class="gfDesc">' + desc + '</div>';
      _template += '</div>';
      $element.after(_template);

      const $gfColorPicker = $element.next('.gfColorPicker');
      const $inputPickerBody = $gfColorPicker.find('.gfColorPickerBody .box input.color-picker');
      const $inputPickerIrrs = $gfColorPicker.find('.gfColorPickerBody .irrs');
      const $iconChevronDown = $gfColorPicker.find('.gfColorPickerBody .icon-chevron_down');
      const $opacityColorTypo = $gfColorPicker.find('.gfColorPickerBody .color-action .opacity input');
      const $unlinkEle = $gfColorPicker.find('.gfColorPickerBody .unlink');
      $unlinkEle.gfTooltipsNew({
        postion: 'top',
        backgroundColor: '#676767',
        desc: 'Unlink style',
      });

      if (!_hide) {
        var merOldBackupSettings;
        var merOldBackupDesignOptions;

        var inputName = $element.attr('name');
        var inputId = $element.attr('id');
        $inputPickerBody.focus(function () {
          const $this = jQuery(this);
          _isHistoryEditing = true;

          const oldValue = $element.attr('value');
          const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
          switch (currentTab) {
            case 'Settings':
              setTimeout(function () {
                merOldBackupSettings = $gryffEditor.data('gfhistory').setMERBackupSettings();
              }, 51);

              $gryffBody.off('mousedown.history').on('mousedown.history', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history');
                  jQuery('body').off('mousedown.history');
                }
              });

              jQuery('body')
                .off('mousedown.history')
                .on('mousedown.history', function (e) {
                  const $target = jQuery(e.target);

                  if (!$target.is($this)) {
                    if (oldValue != $element.attr('value')) {
                      const extra = {
                        flagBKSettings: true,
                      };
                      _this.settings.onHistoryAdded();
                      if (_this.settings.addHistory) {
                        $element.trigger('history-change', extra);
                      }
                    }
                    _isHistoryEditing = false;
                    $gryffBody.off('mousedown.history');
                    jQuery('body').off('mousedown.history');
                  }
                });
              break;

            case 'Design':
              setTimeout(function () {
                merOldBackupDesignOptions = $gryffEditor.data('gfhistory').setMERBackupDesignOptions();
              }, 51);

              $gryffBody.off('mousedown.history.colorpicker').on('mousedown.history.colorpicker', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKDesignOptions: true,
                    };

                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.colorpicker');
                  jQuery('body').off('mousedown.history.colorpicker');
                }
              });

              jQuery('body')
                .off('mousedown.history.colorpicker')
                .on('mousedown.history.colorpicker', function (e) {
                  const $target = jQuery(e.target);

                  if (!$target.is($this)) {
                    if (oldValue != $element.attr('value')) {
                      const extra = {
                        flagBKDesignOptions: true,
                      };
                      if (_this.settings.addHistory) {
                        $element.trigger('history-change', extra);
                      }
                    }
                    _isHistoryEditing = false;
                    $gryffBody.off('mousedown.history.colorpicker');
                    jQuery('body').off('mousedown.history.colorpicker');
                  }
                });

              break;
          }
        });
        this.initIrisPopupPickColor($gfColorPicker.find('.gfColorPickerBody'), value);

        let focus = false;
        $gfColorPicker.find('.iris-picker').on('mousedown.history.colorpicker', function () {
          const $this = jQuery(this);
          if (!focus) {
            focus = true;
            _isHistoryEditing = true;
            const oldValue = $element.attr('value');
            const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
            switch (currentTab) {
              case 'Settings':
                setTimeout(function () {
                  merOldBackupSettings = $gryffEditor.data('gfhistory').setMERBackupSettings();
                }, 51);
                $gryffBody.off('mousedown.history').on('mousedown.history.colorpicker', function (e) {
                  const $target = jQuery(e.target);

                  if (!$target.is($this)) {
                    if (oldValue != $element.attr('value')) {
                      const extra = {
                        flagBKSettings: true,
                      };
                      // _this.settings.onHistoryAdded();
                      $element.trigger('history-change', extra);
                    }
                    focus = false;
                    _isHistoryEditing = false;
                    $gryffBody.off('mousedown.history.colorpicker');
                    jQuery('body').off('mousedown.history.colorpicker');
                  }
                });

                jQuery('body')
                  .off('mousedown.history')
                  .on('mousedown.history.colorpicker', function (e) {
                    const $target = jQuery(e.target);

                    if (!$target.is($this)) {
                      if (oldValue != $element.attr('value')) {
                        const extra = {
                          flagBKSettings: true,
                        };
                        // _this.settings.onHistoryAdded();
                        $element.trigger('history-change', extra);
                      }
                      focus = false;
                      _isHistoryEditing = false;
                      $gryffBody.off('mousedown.history.colorpicker');
                      jQuery('body').off('mousedown.history.colorpicker');
                    }
                  });
                break;

              case 'Design':
                setTimeout(function () {
                  merOldBackupDesignOptions = $gryffEditor.data('gfhistory').setMERBackupDesignOptions();
                }, 51);

                $gryffBody.off('mousedown.history.colorpicker').on('mousedown.history.colorpicker', function (e) {
                  const $target = jQuery(e.target);
                  if (!$target.is($this)) {
                    if (oldValue != $element.attr('value')) {
                      const extra = {
                        flagBKDesignOptions: true,
                      };
                      $element.trigger('history-change', extra);
                    }
                    focus = false;
                    _isHistoryEditing = false;
                    $gryffBody.off('mousedown.history.colorpicker');
                    jQuery('body').off('mousedown.history.colorpicker');
                  }
                });

                jQuery('body')
                  .off('mousedown.history.colorpicker')
                  .on('mousedown.history.colorpicker', function (e) {
                    const $target = jQuery(e.target);
                    if (!$target.closest('.iris-picker').is($this)) {
                      if (oldValue != $element.attr('value')) {
                        const extra = {
                          flagBKDesignOptions: true,
                        };
                        $element.trigger('history-change', extra);
                      }

                      focus = false;
                      _isHistoryEditing = false;
                      $gryffBody.off('mousedown.history.colorpicker');
                      jQuery('body').off('mousedown.history.colorpicker');
                    }
                  });

                break;
            }
          }
        });
      } else {
        var merOldBackupSettings;
        var merOldBackupDesignOptions;

        var inputName = $element.attr('name');
        var inputId = $element.attr('id');
        this.applyEventForInputColorPicker();

        $inputPickerBody.focus(function () {
          const $this = jQuery(this);
          _isHistoryEditing = true;
          const oldValue = $element.attr('value');
          const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
          switch (currentTab) {
            case 'Settings':
              setTimeout(function () {
                merOldBackupSettings = $gryffEditor.data('gfhistory').setMERBackupSettings();
              }, 51);
              $gryffBody.off('mousedown.history.colorpicker').on('mousedown.history.colorpicker', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.colorpicker');
                  jQuery('body').off('mousedown.history.colorpicker');
                }
              });

              jQuery('body')
                .off('mousedown.history.colorpicker')
                .on('mousedown.history.colorpicker', function (e) {
                  const $target = jQuery(e.target);

                  if (!$target.is($this)) {
                    if (oldValue != $element.attr('value')) {
                      const extra = {
                        flagBKSettings: true,
                      };
                      _this.settings.onHistoryAdded();
                      if (_this.settings.addHistory) {
                        $element.trigger('history-change', extra);
                      }
                    }
                    _isHistoryEditing = false;
                    $gryffBody.off('mousedown.history.colorpicker');
                    jQuery('body').off('mousedown.history.colorpicker');
                  }
                });
              break;

            case 'Design':
              setTimeout(function () {
                merOldBackupDesignOptions = $gryffEditor.data('gfhistory').setMERBackupDesignOptions();
              }, 51);

              $gryffBody.off('mousedown.history.colorpicker').on('mousedown.history.colorpicker', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKDesignOptions: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.colorpicker');
                  jQuery('body').off('mousedown.history.colorpicker');
                }
              });

              jQuery('body')
                .off('mousedown.history.colorpicker')
                .on('mousedown.history.colorpicker', function (e) {
                  const $target = jQuery(e.target);

                  if (!$target.is($this)) {
                    if (oldValue != $element.attr('value')) {
                      const extra = {
                        flagBKDesignOptions: true,
                      };
                      _this.settings.onHistoryAdded();
                      if (_this.settings.addHistory) {
                        $element.trigger('history-change', extra);
                      }
                    }
                    _isHistoryEditing = false;
                    $gryffBody.off('mousedown.history.colorpicker');
                    jQuery('body').off('mousedown.history.colorpicker');
                  }
                });

              break;
          }
        });

        // Mở Popup Pick Color
        $inputPickerIrrs.off('click.show').on('click.show', function (e) {
          preset = app.$store.getters['sidebar/getCurrentPresetInPage'];
          const gsColors = generateGSColors();
          const gsColorsLength = Object.keys(gsColors).length;
          if (gsColorsLength) {
            let templateColors = '';
            for (const color in gsColors) {
              const styleAlphaColor = `
                background: ${gsColors[color]};
                border: 1px solid ${
                  window.tinycolor(gsColors[color]).isDark()
                    ? window.tinycolor.mix(gsColors[color], 'white', 30).toHex8String()
                    : window.tinycolor.mix(gsColors[color], 'black', 30).toHex8String()
                }
              `;
              templateColors += `<div class="wrapper-item"><div class="item"><div class="alpha gs-color-alpha" data-color="${color}" style="${styleAlphaColor}"></div></div></div>`;
            }
            $popup.find('.gf_color-palette .colors').html(templateColors);
          }
          $popup
            .find('.gf_color-palette--footer')
            .html(`<span class="edit-styles">${gsColorsLength ? 'Edit styles' : 'Setup Global Style'}</span>`);

          const oldValue = $element.attr('value');
          // oldValue
          if (e.which != 3) {
            const valueElm = $element.val();

            // Click để tăng index cho poup nổi lên.
            $element.click();

            // Loại bỏ sự kiện của input history;
            $gryffBody.off('mousedown.history.colorpicker');
            jQuery('body').off('mousedown.history.colorpicker');

            let $dad = $element.closest('.gfSettingGroup');
            if ($dad.length == 0) {
              $dad = $element.closest('.repeator'); // Color picker inside repeator
            }
            $dad.css({
              'z-index': '30',
            });
            // _this.settings.onOpacity();
            $dad.parent().prepend('<div class="gf_color-picker" ></div>');

            $dad.after($popup);

            const $popupGsColorAlpha = $dad.next('.gfColorPickerPopup').find('.gs-color-alpha');
            $popupGsColorAlpha.each(function () {
              const gsKeyColor = jQuery(this).attr('data-color');
              jQuery(this).gfTooltipsNew({
                postion: 'top',
                timeIn: 0,
                timeOut: 0,
                backgroundColor: '#676767',
                desc: COLOR_KEYS_MAP_STYLE_NAME[gsKeyColor],
              });
            });

            jQuery('#tabs div a').removeClass('active');
            jQuery('.content-tab').hide();
            if (valueElm.toString().includes('var(--gf_gs-')) {
              jQuery('#tabs div a:first').addClass('active');
              const dataColor = Object.keys(COLOR_KEYS_MAP).find(
                (key) => COLOR_KEYS_MAP[key] === valueElm.toString().match(/var\(--(.*)\)/)[1],
              );
              $gfLeftSideBar
                .find(`.content-tab:first .item [data-color='${dataColor}']`)
                .parents('.wrapper-item')
                .addClass('active-color-gs');
              jQuery('.content-tab:first').show();
            } else {
              jQuery('#tabs div a:last').addClass('active');
              jQuery('.content-tab:last').show();
            }
            _this.initActionPopupColor();
            _this.applyEventAfterSetTemplate();
            const eleValue = valueElm == 'transparent' ? 'transparent' : _this.getColorValidByValue(valueElm);
            // INIT
            _this.initIrisPopupPickColor($popup, eleValue);
            _this.getTopPositionPopUp();

            const $popupClear = $popup.find('.clear');
            // TODO: $popupClear
            $popupClear.click(function () {
              _this.setValueNoneForInputColor('none', $gfColorPicker, $popup);
            });

            // background phủ iframe
            $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('backgroundColoPicker');
            const $gfSGBackground = $gfLeftSideBar.find('.gfSGBackground');
            setTimeout(function () {
              $gryffBody
                .find('.backgroundColoPicker')
                .off('mousedown.removeBackground')
                .on('mousedown.removeBackground', function () {
                  if (oldValue != $element.attr('value')) {
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change');
                    }
                  }

                  try {
                    $popup.find('.box input.color-picker').iris('hide');
                  } catch (err) {}

                  $popup.remove();
                  $gfSGBackground.off('mousedown.picker');
                  _this.settings.offOpacity();

                  $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundColoPicker');
                  $dad.css({
                    'z-index': 200,
                  });
                });
            }, 0);
            $gfSGBackground.off('mousedown.picker').on('mousedown.picker', function (e) {
              $gfSGBackground.off('mousedown.picker');
              _this.settings.offOpacity();
              $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundColoPicker');
              $dad.css({
                'z-index': 200,
              });
            });
            $gfSGBackground.css('zIndex', '-1');
            $gfLeftSideBar
              .find('.gf_color-picker')
              .off('mousedown.picker')
              .on('mousedown.picker', function (e) {
                const $that = $(this);
                if (e.which != '3') {
                  $gfSGBackground.css('zIndex', '');
                  $that.off('mousedown.picker');
                  $that.remove();
                  const $target = jQuery(e.target);
                  if ($target.closest('.gfColorPickerPopup').length == 0) {
                    try {
                      if (oldValue != $element.attr('value')) {
                        _this.settings.onHistoryAdded();
                        if (_this.settings.addHistory) {
                          $element.trigger('history-change');
                        }
                      }
                      $popup.find('.box input.color-picker').iris('hide');
                    } catch (err) {}
                    $popup.remove();
                  }
                  $dad.css({
                    'z-index': 200,
                  });
                }
              });

            // firefox fix
            $gfLeftSideBar.focus();
            $gfLeftSideBar.off('mouseup');
          }
        });

        $iconChevronDown.on('click', function () {
          $inputPickerIrrs.click();
        });
      }

      _this.setValue(value);

      // Clear color
      const $pickerClear = $gfColorPicker.find('.gfColorPickerBody .clear');

      // TODO: $pickerClear
      $pickerClear.click(function () {
        _this.setValueNoneForInputColor('none', $gfColorPicker);
      });
      return false;
    };

    this.setValueNoneForInputColor = function (color, $gfColorPicker, $popup = '') {
      if ($popup) {
        if ((color == 'none' || color == 'transparent') && $popup.find('.box input.color-display').val() != color) {
          $popup.find('.box input.color-picker').attr('color-unlink', color).iris({ color: 'rgba(0, 0, 0, 0)' });
        }
        $popup.find('.box input.color-picker').attr('value', color).val(color);
        $popup.find('.box input.color-display').attr('value', color).val(color);
        $popup.find('.opacity input').attr('value', 0).val(0);
        _this.setSpanColorPreviewOnPopup(color, $popup);
      }
      $gfColorPicker.find('.gfColorPickerBody .opacity input').attr('value', 0).val(0).removeAttr('disabled');
      $gfColorPicker
        .find('.gfColorPickerBody .box input.color-picker')
        .attr('value', color)
        .val(color)
        .removeAttr('disabled');
      $gfColorPicker
        .find('.gfColorPickerBody .box input.color-display')
        .attr('value', color)
        .val(color)
        .removeAttr('disabled');
      _this.setSpanColorPreview(color);

      $element.attr('value', color).val(color).trigger('color-change').trigger('input-change');
      return;
    };

    /*
     * Add Event Sau khi khởi tạo Popup Pick Color
     */
    this.applyEventAfterSetTemplate = function () {
      const _this = this;
      const oldValue = $element.attr('value');
      jQuery('#tabs div a').click(function () {
        const t = jQuery(this).attr('id');
        if (!jQuery(this).hasClass('active')) {
          jQuery('#tabs div a').removeClass('active');
          jQuery(this).addClass('active');
          jQuery('.content-tab').hide();
          jQuery('#' + t + '-content').fadeIn('slow');
          _this.initActionPopupColor();
        }
      });

      jQuery('.close-popup').click(function () {
        if (oldValue != $element.attr('value')) {
          _this.settings.onHistoryAdded();
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
        }
        _this.closePopupColorPicker();
      });

      jQuery('.wrapper-item').hover(function () {
        jQuery(this).addClass('hover-color-gs');
      });

      jQuery('.wrapper-item').mouseleave(function () {
        jQuery(this).removeClass('hover-color-gs');
      });
      jQuery('.gs-color-alpha').click(function () {
        const dataTooltip = jQuery(this).data('gftooltipsnew');
        if (dataTooltip) {
          dataTooltip.stop();
        }
        const gsKeyColor = jQuery(this).attr('data-color');
        const colorByKey = `var(--${COLOR_KEYS_MAP[gsKeyColor]})`;
        _this.setValue(colorByKey, true);
        _this.setSpanColorPreviewOnPopup('none', jQuery('.gfColorPickerPopup'));

        if (oldValue !== colorByKey) {
          _this.settings.onHistoryAdded();
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
        }
        _this.closePopupColorPicker();
      });

      jQuery('.edit-styles').click(function () {
        app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', { key: 'global_style' });
        setTimeout(() => {
          if (preset) {
            app.$store.commit('sidebar/setPreviewPreset', true);
            app.$store.commit('sidebar/setCurrentPreset', preset);
            app.$store.commit('sidebar/SET_VIEW_TARGET_PRESET', 'LIVE_THEME_PRESET');
            setTimeout(() => {
              app.$store.commit('sidebar/SET_COMPONENT_TARGET_GLOBAL_STYLE', dropPresetValueStyle.colorStyle);
            }, 0);
          }
        }, 0);
        _this.closePopupColorPicker();
        app.$store.commit('sidebar/SET_VIEW_TARGET_PRESET', '');
        app.$store.commit('sidebar/SET_COMPONENT_TARGET_GLOBAL_STYLE', '');
      });
      return false;
    };

    /*
     * Khởi tạo IRIS
     */
    this.initIrisPopupPickColor = function ($popup, eleValue) {
      let colorIris = eleValue;
      const isSelectedGS = this.isValueGS(eleValue);
      if (eleValue == 'none' || eleValue == 'transparent' || isSelectedGS) {
        colorIris = 'rgba(0, 0, 0, 0)';
      }
      $popup.find('.box input.color-picker').iris({
        width: 216,
        height: 100,
        hide: false,
        border: false,
        color: colorIris,
      });
      const $popupInputDisplay = $popup.find('.box input.color-display');
      if (!$popupInputDisplay.val()) {
        $popupInputDisplay.val('none').attr('value', 'none');
        $popup.find('.opacity input').val(0).attr('value', 0);
      } else {
        if (eleValue == 'none' || eleValue == 'transparent' || isSelectedGS) {
          $popup.find('.opacity input').val(0).attr('value', 0);
          const value = isSelectedGS ? 'none' : eleValue;
          $popup.find('.box input.color-display').val(value).attr('value', value);
        } else {
          const $gfColorPicker = $element.next('.gfColorPicker');
          const valOpacity = $gfColorPicker.find('.gfColorPickerBody .opacity input').val();
          const eleHexValue = window.tinycolor(eleValue).isValid()
            ? window.tinycolor(eleValue).toHexString()
            : eleValue;
          const eleAlpValue = window.tinycolor(eleValue).isValid()
            ? Math.round(window.tinycolor(eleValue).getAlpha() * 100)
            : valOpacity;

          $popup.find('.opacity input').val(eleAlpValue).attr('value', eleAlpValue);

          const styleIrrs = this.getStyleOnSpanPreview(eleValue);
          $popup.find('.gfColorPickerText span.irrs').css(styleIrrs);
          $popupInputDisplay.val(eleHexValue).attr('value', eleHexValue);
        }
      }
      // TODO:
      // Sau khi iris change value thi tra ve gia tri mau + tai input
      const $gfColorPicker = $element.next('.gfColorPicker');
      $popup.find('.box input.color-picker').iris({
        change: function (event, ui) {
          if (!_isTypingColor) {
            let nColor = ui.color.to_s();
            const valueOld = $popup.find('.box input.color-display').val();
            let isOnFocus = false;
            if (
              $popup.find('.box input.color-display').is(':focus') ||
              $gfColorPicker.find('.gfColorPickerBody .box input.color-display').is(':focus')
            ) {
              const nColorRgb = window.tinycolor(nColor).toRgbString();
              const valueOldRgb = window.tinycolor(valueOld).toRgbString();
              if (nColorRgb == valueOldRgb) {
                isOnFocus = true;
              }
            }
            if (!isOnFocus) {
              if ($popup.find('.box input.color-picker').attr('color-unlink') == 'none') {
                $popup.find('.box input.color-picker').attr('color-unlink', '');
                return false;
              }
              // color-unlink
              const ampNColor = window.tinycolor(nColor).getAlpha();
              let isTriggerIris = false;
              if (
                (valueOld == 'none' || valueOld == 'transparent' || !window.tinycolor(valueOld).isValid()) &&
                ampNColor == 0
              ) {
                isTriggerIris = true;
                nColor = _this.convertToRgba(nColor, 1);
              }
              _this.handleBlurInputColorDisplay(nColor, $gfColorPicker, $popup);
              _this.setSpanColorPreviewOnPopup(nColor, $popup);
              _this.setSpanColorPreview(nColor);
              if (isTriggerIris) {
                $popup.find('.box input.color-picker').iris({ color: nColor });
              }
            }
          }
          return false;
        },
      });
      _this.applyEventForInputColorPickerOnPopup($popup);
      return false;
    };

    this.setColorInputAfterChange = function (color, $popup) {
      const $gfColorPicker = $element.next('.gfColorPicker');
      if ($popup) {
        $popup.find('.box input.color-picker').attr('value', color).val(color);
        $popup.find('.box input.color-display').attr('value', color).val(color);
        $popup.find('.opacity input').attr('value', 100).val(100);
        _this.setSpanColorPreviewOnPopup(color, $popup);
      }
      $gfColorPicker.find('.gfColorPickerBody .opacity input').attr('value', 100).val(100);
      $gfColorPicker.find('.gfColorPickerBody .box input.color-picker').attr('value', color).val(color);
      $gfColorPicker.find('.gfColorPickerBody .box input.color-display').attr('value', color).val(color);
      _this.setSpanColorPreview(color);

      _this.handleBlurInputColorDisplay(color, $gfColorPicker, $popup);
      $element.attr('value', color).val(color).trigger('color-change').trigger('input-change');
    };

    this.getColorValidByValue = function (value) {
      return window.tinycolor(value).isValid() ? window.tinycolor(value).toRgbString() : value;
    };

    this.closePopupColorPicker = function () {
      let $dad = $element.closest('.gfSettingGroup');
      if ($dad.length == 0) {
        $dad = $element.closest('.repeator'); // Color picker inside repeator
      }
      const $popup = $dad.next('.gfColorPickerPopup');
      try {
        $popup.find('.box input.color-picker').iris('hide');
      } catch (err) {}
      $popup.remove();

      $gfLeftSideBar.find('.gfSGBackground').off('mousedown.picker');
      _this.settings.offOpacity();
      $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundColoPicker');
      $dad.css({
        'z-index': 200,
      });
      return false;
    };

    this.applyEventForInputColorPicker = function () {
      const $gfColorPicker = $element.next('.gfColorPicker');
      const $inputColorDisplay = $gfColorPicker.find('.gfColorPickerBody .box input.color-display');
      const $inputColorPicker = $gfColorPicker.find('.gfColorPickerBody .box input.color-picker');
      const $opacityColorTypo = $gfColorPicker.find('.gfColorPickerBody .color-action .opacity input');
      // Thay đổi value Input Opacity
      $opacityColorTypo.off('keyup paste').on('keyup paste', function (e) {
        _isOnfocusInput = true;
        const $that = jQuery(this);
        let opacity = Math.round($that.val()) / 100;
        if (opacity < 0 || isNaN(opacity)) {
          opacity = 0;
        } else if (opacity > 1) {
          opacity = 1;
        }
        const valInputColorDisplay = $gfColorPicker.find('.gfColorPickerBody .box input.color-display').val();
        if (window.tinycolor(valInputColorDisplay).isValid()) {
          const color = _this.convertToRgba(valInputColorDisplay, opacity);
          _this.setSpanColorPreview(color);
          $element
            .attr('value', color)
            .val(color)
            .attr('value-old', color)
            .trigger('color-change')
            .trigger('input-change');
        }
        return false;
      });
      $opacityColorTypo.off('blur').on('blur', function (e) {
        _isOnfocusInput = false;
        const $that = jQuery(this);
        const opacity = Math.round($that.val()) / 100;
        if (opacity < 0 || isNaN(opacity)) {
          setTimeout(() => {
            $that.val(0).attr('value', 0);
          }, 100);
        } else if (opacity > 1) {
          setTimeout(() => {
            $that.val(100).attr('value', 100);
          }, 100);
        }
        return false;
      });
      $inputColorDisplay.off('keyup paste').on('keyup paste', function (e) {
        _isOnfocusInput = true;
        const $that = jQuery(this);
        let nColor = $that.val();
        const isChangedValue = _this.checkValInputColorPicker(nColor);
        if (isChangedValue) {
          // Check Value Khi input vs Value Element => Nếu bằng nhau
          return;
        }
        if (window.tinycolor(nColor).isValid()) {
          nColor = window.tinycolor(nColor).toRgbString();
          const opacity = Math.round(window.tinycolor(nColor).getAlpha() * 100);
          $opacityColorTypo.attr('value', opacity).val(opacity);
        } else {
          $opacityColorTypo.attr('value', 0).val(0);
        }
        _this.setSpanColorPreview(nColor);
        $that.trigger('input-change');
        $element.attr('value', nColor).val(nColor).trigger('color-change').trigger('input-change');
      });
      $inputColorDisplay.off('blur').on('blur', function (e) {
        _isOnfocusInput = false;
        const color = jQuery(this).val(); // Giá trị màu Nhập / Paste chưa được conver
        const isChangedValue = _this.checkValInputColorPicker(color);
        if (isChangedValue) {
          // Check Value Khi input vs Value Element => Nếu bằng nhau
          return;
        }
        _this.handleBlurInputColorDisplay(color, $gfColorPicker); // Convert giá trị màu hiển thị
      });

      return false;
    };

    this.applyEventForInputColorPickerOnPopup = function ($popup) {
      const $gfColorPicker = $element.next('.gfColorPicker');
      const $inputColorDisplay = $gfColorPicker.find('.gfColorPickerBody .box input.color-display');
      const $popupInput = $popup.find('.box input.color-picker');
      const $opacityPopup = $popup.find('.opacity input');
      const $opacityBody = $gfColorPicker.find('.gfColorPickerBody .color-action .opacity input');
      $opacityPopup.off('keyup paste').on('keyup paste', function (e) {
        _isOnfocusInput = true;
        const $that = jQuery(this);
        const valOpacity = $that.val();
        let opacity = Math.round($that.val()) / 100;
        if (opacity < 0 || isNaN(opacity)) {
          opacity = 0;
        } else if (opacity > 1) {
          opacity = 1;
        }
        const valInputColorDisplay = $gfColorPicker.find('.gfColorPickerBody .box input.color-display').val();
        if (window.tinycolor(valInputColorDisplay).isValid()) {
          const color = _this.convertToRgba(valInputColorDisplay, opacity);
          $popupInput.iris('color', color);
          $gfColorPicker
            .find('.gfColorPickerBody .color-action .opacity input')
            .attr('value', valOpacity)
            .val(valOpacity);
          _this.setSpanColorPreview(color);
          _this.setSpanColorPreviewOnPopup(color, $popup);
          $element
            .attr('value', color)
            .val(color)
            .attr('value-old', color)
            .trigger('color-change')
            .trigger('input-change');
        }
        return false;
      });
      $opacityPopup.off('blur').on('blur', function (e) {
        _isOnfocusInput = false;
        const $that = jQuery(this);
        const opacity = Math.round($that.val()) / 100;
        if (opacity < 0 || isNaN(opacity)) {
          setTimeout(() => {
            $that.val(0).attr('value', 0);
          }, 100);
        } else if (opacity > 1) {
          setTimeout(() => {
            $that.val(100).attr('value', 100);
          }, 100);
        }
        return false;
      });
      $popup
        .find('.box input.color-display')
        .off('keyup paste')
        .on('keyup paste', function (e) {
          _isOnfocusInput = true;
          const $that = jQuery(this);
          let nColor = $that.val();
          const isChangedValue = _this.checkValInputColorPicker(nColor);
          if (isChangedValue) {
            // Check Value Khi input vs Value Element => Nếu bằng nhau
            return;
          }

          // Change Value IRIS
          const nColorRgba = _this.getColorValidByValue(nColor);
          $popupInput.val(nColorRgba).attr('value', nColorRgba);
          $popupInput.iris('color', nColorRgba);

          // Set Input Không nằm trong Popup
          $inputColorDisplay.val(nColor).attr('value', nColor);

          if (window.tinycolor(nColor).isValid()) {
            nColor = window.tinycolor(nColor).toRgbString();
            const opacity = Math.round(window.tinycolor(nColor).getAlpha() * 100);
            $opacityPopup.attr('value', opacity).val(opacity);
            $opacityBody.attr('value', opacity).val(opacity);
          } else {
            $opacityPopup.attr('value', 0).val(0);
            $opacityBody.attr('value', 0).val(0);
          }
          _this.setSpanColorPreviewOnPopup(nColor, $popup);
          $that.trigger('input-change');
          // Set ELM input
          $element.attr('value', nColor).val(nColor).trigger('color-change').trigger('input-change');
          _this.setSpanColorPreview(nColor);
        });
      $popup
        .find('.box input.color-display')
        .off('blur')
        .on('blur', function (e) {
          _isOnfocusInput = false;
          const color = jQuery(this).val(); // Giá trị màu Nhập / Paste chưa được conver
          const isChangedValue = _this.checkValInputColorPicker(color);
          if (isChangedValue) {
            // Check Value Khi input vs Value Element => Nếu bằng nhau
            return;
          }
          _this.handleBlurInputColorDisplay(color, $gfColorPicker, $popup); // Convert giá trị màu hiển thị
        });
      return false;
    };

    this.checkValInputColorPicker = function (valCurrent, $gfColorPicker = '') {
      if (!$gfColorPicker) {
        $gfColorPicker = $element.next('.gfColorPicker');
      }
      if (!window.tinycolor(valCurrent).isValid()) {
        return false;
      }
      // check is hex 6 số
      // Check hex 6 hiện tại có bằng hex 6 số cũ
      if (this.isHex6Color(valCurrent)) {
        if (!$element.attr('value-old')) {
          const elementVal = window.tinycolor($element.val()).isValid()
            ? window.tinycolor($element.val()).toHexString()
            : $element.val();
          if (valCurrent == elementVal) {
            return true;
          }
        } else {
          if (valCurrent == $element.attr('value-old')) {
            return true;
          }
        }
      }
      const $opacityColor = $gfColorPicker.find('.gfColorPickerBody .opacity input');
      const valOpacity = $opacityColor.val() / 100; // lấy số thập phân
      const valColorPickerRgba = this.convertToRgba(window.tinycolor(valCurrent).toHexString(), valOpacity);
      const valColorRgbaTiny = window.tinycolor(valColorPickerRgba).toRgbString();
      const valElmRgba = window.tinycolor($element.attr('value-old')).toRgbString();
      if (valElmRgba == valColorRgbaTiny) {
        // Nêu Value của Input ELM == Value Input đang nhập
        return true;
      }
      return false;
    };

    this.setColorInput = throttle(function (nColor) {
      _this.setValue(nColor);
      _this.settings.onSelected(nColor, $element);
      $element.attr('value', nColor).val(nColor).trigger('color-change').trigger('input-change');
    });

    this.isValueGS = function (value) {
      const regex = /var\(--gf_gs-(.*)\)/;
      return value.match(regex);
    };

    this.setValue = function (value, isSelectColor = false) {
      _this.initActionPopupColor();
      const $gfColorPicker = $element.next();
      const $inputColor = $gfColorPicker.find('.gfColorPickerBody input');
      const $opacityColor = $gfColorPicker.find('.gfColorPickerBody .opacity input');
      const $spanColor = $gfColorPicker.find('.gfColorPickerBody span.irrs');

      const $popupInputColor = $popup.find('.gfColorPickerText .box input.color-display');
      const $popupOpacityColor = $popup.find('.gfColorPickerText .opacity input');
      const $popupSpanColor = $popup.find('.gfColorPickerText span.irrs');

      const $boxInputColor = $gfColorPicker.find('.gfColorPickerBody .box-action');
      const $boxInputColorCustom = $gfColorPicker.find('.gfColorPickerBody .color-action');
      const $unlinkEle = $gfColorPicker.find('.gfColorPickerBody .unlink');

      $inputColor.removeAttr('disabled');
      $boxInputColorCustom.css({ display: 'flex' });
      $boxInputColor.css({ display: 'none' });

      if (!value) return;
      const matchValueCheckGSColor = this.isValueGS(value);
      if (matchValueCheckGSColor) {
        $boxInputColorCustom.css({ display: 'none' });
        $boxInputColor.css({ display: 'flex' });
        const keyColorMap = matchValueCheckGSColor[1];
        const splitKeyColorMap = keyColorMap.split('-');
        const titleMapValue = DEFAULT_PRESET_CLASS.colors[splitKeyColorMap[1]][splitKeyColorMap[0]].title;
        $inputColor.val(titleMapValue).attr('value', titleMapValue);
        $element.attr('value', value).val(value).trigger('color-change');
        if (isSelectColor) {
          $inputColor.attr('disabled', 'disabled');
          $element.trigger('input-change');
        }
        $spanColor.html('');
        $spanColor.css({
          background: value,
          border: `1px solid ${
            window.tinycolor(value).isDark()
              ? window.tinycolor.mix(value, 'white', 30).toHex8String()
              : window.tinycolor.mix(value, 'black', 30).toHex8String()
          }`,
        });
        $opacityColor.val(100).attr('value', 100);
        $unlinkEle.on('click', function () {
          $inputColor.removeAttr('disabled');
          preset = app.$store.getters['sidebar/getCurrentPresetInPage'];
          gsColors = generateGSColors();
          const orgColor = gsColors[`${splitKeyColorMap[1]}-${splitKeyColorMap[0]}`] || 'transparent';

          $popup.find('.gfColorPickerText .box input.color-picker').iris({
            width: 216,
            height: 100,
            hide: false,
            border: false,
            color: window.tinycolor(orgColor).toRgbString(),
          });

          const hexColor = window.tinycolor(orgColor).toHexString();
          const alphaColor = Math.round(window.tinycolor(orgColor).getAlpha() * 100);
          $inputColor.val(hexColor).attr('value', hexColor);
          $element.attr('value', orgColor).val(orgColor).trigger('color-change').trigger('input-change');
          _this.settings.onHistoryAdded();
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
          $popupOpacityColor.val(alphaColor).attr('value', alphaColor);
          $popupSpanColor.html('');
          const styleIrrs = {
            background: orgColor,
            border: `1px solid ${
              window.tinycolor(orgColor).isDark()
                ? window.tinycolor.mix(orgColor, 'white', 30).toHex8String()
                : window.tinycolor.mix(orgColor, 'black', 30).toHex8String()
            }`,
          };
          $popupSpanColor.css(styleIrrs);
          $opacityColor.val(alphaColor).attr('value', alphaColor);
          $spanColor.html('');
          $spanColor.css(styleIrrs);
          if (orgColor == 'transparent') {
            $popupSpanColor.html(
              '<svg class="help-me-name-it-bruh" height="21px" viewBox="0 0 21 21"><path d="M2,0h17c1.1,0,2,0.9,2,2v17c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z" style="fill: #EBEBEC" /><path d="M18,18h3v1c0,1.1-0.9,2-2,2h-1V18z M12,18h3v3h-3V18z M6,18h3v3H6V18z M0,18h3v3H2c-1.1,0-2-0.9-2-2V18z M15,15h3v3h-3V15z M9,15h3v3H9V15z M3,15h3v3H3V15z M18,12h3v3h-3V12z M12,12h3v3h-3V12z M6,12h3v3H6V12z M0,12h3v3H0V12z M15,9h3v3h-3V9zM9,9h3v3H9V9z M3,9h3v3H3V9z M18,6h3v3h-3V6z M12,6h3v3h-3V6z M6,6h3v3H6V6z M0,6h3v3H0V6z M15,3h3v3h-3V3z M9,3h3v3H9V3z M3,3h3v3H3V3z M18,0h1c1.1,0,2,0.9,2,2v1h-3V0z M12,0h3v3h-3V0z M6,0h3v3H6V0z M2,0h1v3H0V2C0,0.9,0.9,0,2,0z" style="fill: rgba(60,60,60,0.2);" /></svg>',
            );
            $popupOpacityColor.html(0);
            $spanColor.html(
              '<svg class="help-me-name-it-bruh" height="21px" viewBox="0 0 21 21"><path d="M2,0h17c1.1,0,2,0.9,2,2v17c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z" style="fill: #EBEBEC" /><path d="M18,18h3v1c0,1.1-0.9,2-2,2h-1V18z M12,18h3v3h-3V18z M6,18h3v3H6V18z M0,18h3v3H2c-1.1,0-2-0.9-2-2V18z M15,15h3v3h-3V15z M9,15h3v3H9V15z M3,15h3v3H3V15z M18,12h3v3h-3V12z M12,12h3v3h-3V12z M6,12h3v3H6V12z M0,12h3v3H0V12z M15,9h3v3h-3V9zM9,9h3v3H9V9z M3,9h3v3H3V9z M18,6h3v3h-3V6z M12,6h3v3h-3V6z M6,6h3v3H6V6z M0,6h3v3H0V6z M15,3h3v3h-3V3z M9,3h3v3H9V3z M3,3h3v3H3V3z M18,0h1c1.1,0,2,0.9,2,2v1h-3V0z M12,0h3v3h-3V0z M6,0h3v3H6V0z M2,0h1v3H0V2C0,0.9,0.9,0,2,0z" style="fill: rgba(60,60,60,0.2);" /></svg>',
            );
            $opacityColor.val(0).attr('value', 0);
          }
          $popupInputColor.attr('value', hexColor).val(hexColor);
          $boxInputColorCustom.css({
            display: 'flex',
          });
          $boxInputColor.css({
            display: 'none',
          });
        });
      } else {
        $boxInputColorCustom.css({ display: 'flex' });
        $boxInputColor.css({ display: 'none' });
        let hexValue = value;
        let hexAlpha = '';

        if (value == '' || value == 'none' || value == 'transparent') {
          $popupSpanColor.css({
            background: 'transparent',
          });
          $spanColor.css({
            background: 'transparent',
          });
          hexAlpha = 0;
        } else {
          $popupSpanColor.html('');
          const hex = _this.convertToHex(value);
          hexValue = hex.value;
          hexAlpha = Math.round(window.tinycolor(value).getAlpha() * 100);
          const styleIrrs = {
            background: value,
            border: `1px solid ${
              window.tinycolor(value).isDark()
                ? window.tinycolor.mix(value, 'white', 30).toHex8String()
                : window.tinycolor.mix(value, 'black', 30).toHex8String()
            }`,
          };
          $popupSpanColor.css(styleIrrs);
          $spanColor.html('');
          $spanColor.css(styleIrrs);
        }
        $element.attr('value', value).val(value).trigger('color-change');
        $popupOpacityColor.val(hexAlpha).attr('value', hexAlpha);
        // input hidden with origin value
        if (!_isTypingColor) {
          $inputColor.val(hexValue).attr('value', hexValue);
          $popupInputColor.val(hexValue).attr('value', hexValue);
        }
        $opacityColor.val(hexAlpha).attr('value', hexAlpha);
      }

      return false;
    };

    this.setSpanColorPreview = function (color) {
      const $gfColorPicker = $element.next();
      const $spanColor = $gfColorPicker.find('.gfColorPickerBody span.irrs');
      const $popupSpanColor = $popup.find('.gfColorPickerText span.irrs');
      const styleIrrs = this.getStyleOnSpanPreview(color);
      $spanColor.html('');
      $popupSpanColor.html('');
      $spanColor.css(styleIrrs);
      $popupSpanColor.css(styleIrrs);

      $gfColorPicker.find('.gfColorPickerBody .color-action').css({ display: 'flex' });
      $gfColorPicker.find('.gfColorPickerBody .box-action').css({ display: 'none' });

      return;
    };

    this.setSpanColorPreviewOnPopup = function (color, $popup) {
      const styleIrrs = _this.getStyleOnSpanPreview(color);
      $popup.find('.gfColorPickerText span.irrs').css(styleIrrs);
      return;
    };

    this.getStyleOnSpanPreview = function (color) {
      let styleIrrs = {};
      const colorIsvalid = window.tinycolor(color).isValid();
      if (color == '' || color == 'none' || color == 'transparent' || !colorIsvalid) {
        styleIrrs = {
          background: 'transparent',
          border: '1px solid transparent',
        };
      } else {
        styleIrrs = {
          background: color,
          border: `1px solid ${
            window.tinycolor(color).isDark()
              ? window.tinycolor.mix(color, 'white', 30).toHex8String()
              : window.tinycolor.mix(color, 'black', 30).toHex8String()
          }`,
        };
      }
      return styleIrrs;
    };

    /**
     * getHexAndOpacityByColor
     * Return 0 -> 100;
     */
    this.getHexAndOpacityByColor = function (color) {
      let hex, opacity;
      if (window.tinycolor(color).isValid()) {
        hex = window.tinycolor(color).toHexString();
        opacity = Math.round(window.tinycolor(color).getAlpha() * 100);
      } else {
        hex = color;
        opacity = 100;
      }

      return { hex, opacity };
    };

    this.handleBlurInputColorDisplay = throttle(function (color, $gfColorPicker, $popup = '') {
      const dataColor =
        color == 'transparent' || color == 'none' || !window.tinycolor(color).isValid()
          ? { hex: color, opacity: 0 }
          : _this.getHexAndOpacityByColor(color);
      if (color == 'none') {
        _this.setValueNoneForInputColor('none', $gfColorPicker, $popup);
      }
      const hexValue = dataColor.hex;
      const $inputColorDisplay = $gfColorPicker.find('.gfColorPickerBody .box input.color-display');
      $inputColorDisplay.val(hexValue).attr('value', hexValue).removeAttr('disabled');
      const opacity = dataColor.opacity;
      const $opacityColor = $gfColorPicker.find('.gfColorPickerBody .opacity input');
      $opacityColor.val(opacity).attr('value', opacity).removeAttr('disabled'); // Nhận value 0-100
      if ($popup) {
        $popup.find('.box input.color-display').val(hexValue).attr('value', hexValue);
        $popup.find('.opacity input').val(opacity).attr('value', opacity);
      }
      const colorConvert = _this.convertToRgba(hexValue, opacity / 100);
      const colorConvertHex = window.tinycolor(color).isValid() ? window.tinycolor(color).toHexString() : color;
      $element
        .attr('value', colorConvert)
        .attr('value-old', colorConvertHex)
        .val(colorConvert)
        .trigger('color-change')
        .trigger('input-change');
      _this.settings.onSelected(colorConvert, $element);
      return;
    });

    this.setConvertedColorToInput = function (color) {
      const $gfColorPicker = $element.next();
      const $inputColor = $gfColorPicker.find('.gfColorPickerBody .box input.color-display');
      const $opacityColor = $gfColorPicker.find('.gfColorPickerBody .opacity input');
      const $popupInputColor = $popup.find('.gfColorPickerText .box input.color-display');
      const $popupOpacityColor = $popup.find('.gfColorPickerText .opacity input');

      const dataColor = _this.getHexAndOpacityByColor(color);
      const hexValue = dataColor.hex;
      const opacity = dataColor.opacity;

      $popupOpacityColor.val(opacity).attr('value', opacity);
      $opacityColor.val(opacity).attr('value', opacity);
      $inputColor.val(hexValue).attr('value', hexValue);
      $popupInputColor.val(hexValue).attr('value', hexValue);
      return;
    };

    this.initActionPopupColor = function () {
      const $popupBoxInput = $popup.find('.wrap-box .box');
      const $popupInputColor = $popup.find('.wrap-box .box input.color-display');
      const $popupIconClearColor = $popup.find('.icon-clear-color');
      const $popupOpacity = $popup.find('.opacity');

      $popupBoxInput.hover(function () {
        $popupIconClearColor.css({ display: 'flex' });
        $popupInputColor.css({ width: 'calc(100% - 52px)' });
        $popupBoxInput.addClass('active');
      });

      $popupBoxInput.mouseleave(function () {
        $popupIconClearColor.css({ display: 'none' });
        $popupInputColor.css({ width: 'calc(100% - 32px)' });
        $popupBoxInput.removeClass('active');
      });

      $popupIconClearColor.hover(function () {
        $popupIconClearColor.css({ display: 'flex' });
        $popupInputColor.css({ width: 'calc(100% - 52px)' });
        $popupBoxInput.addClass('active');
      });

      $popupOpacity.hover(function () {
        $popupIconClearColor.css({ display: 'none' });
        $popupInputColor.css({ width: 'calc(100% - 32px)' });
        $popupBoxInput.removeClass('active');
        $popupOpacity.addClass('active');
      });

      $popupOpacity.mouseleave(function () {
        $popupOpacity.removeClass('active');
      });

      this.getTopPositionPopUp();
    };

    this.getTopPositionPopUp = function () {
      const $gfColorPicker = $element.next('.gfColorPicker');
      const topGfColorPicker = $gfColorPicker.offset().top;
      const heightSubTitle = $gfColorPicker.find('.gfSGSubTitle').height();
      const maxLengthOfPopup = 300;
      let top = topGfColorPicker;

      if (top + maxLengthOfPopup > $(window).height() - 60) {
        top = topGfColorPicker - $popup.height() - (heightSubTitle ? 0 : 25) - 40;
        if (top < 90) {
          top = 90;
        }
      } else if (top < 0) {
        top = 60;
      } else {
        top = topGfColorPicker + (heightSubTitle ? 25 : 0) - 15;
      }
      $popup.css({
        top: top,
      });

      const $gfSGBackground = $gfColorPicker.parents('.columns').find('.gfSGBackground');
    };

    /**
     * convertToHex
     * @param {*} color
     * @returns alpha: 0->1
     */
    this.convertToHex = function (color) {
      let a,
        opacity,
        rgb = color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
        alpha = ((rgb && rgb[4]) || '').trim();
      let hex;
      if (rgb) {
        hex =
          '#' +
          (rgb[1] | (1 << 8)).toString(16).slice(1) +
          (rgb[2] | (1 << 8)).toString(16).slice(1) +
          (rgb[3] | (1 << 8)).toString(16).slice(1);
      } else {
        hex = window.tinycolor(color).toHexString();
        alpha = HELPER.getRoundNumber(window.tinycolor(color).getAlpha());
      }

      if (alpha !== '') {
        a = HELPER.getRoundNumber(alpha);
      } else {
        a = 1;
      }

      opacity = ((a * 255) | (1 << 8)).toString(16).slice(1);
      return { value: hex, opacity: opacity, alpha: a };
    };

    this.isHex6Color = function (color) {
      return /^#([0-9a-f]{6}){1}$/i.test(color);
    };

    this.convertToRgba = function (color, alpha = 1) {
      const isHexColor = (color) => {
        return /^#([0-9a-f]{3}){1,2}$/i.test(color);
      };

      if (isHexColor(color)) {
        let hex = color;
        const change = (val) => parseInt(val, 16) || 0;
        const convertHexToAlpha = (val) => ((parseInt(val, 16) || 0) / 255).toFixed(2);
        if (hex.toLowerCase().startsWith('0x')) hex = hex.slice(2);
        else hex = hex.slice(1);
        if (hex.length < 4) {
          return `rgba(${change(hex.slice(0, 1).repeat(2))}, ${change(hex.slice(1, 2).repeat(2))}, ${change(
            hex.slice(2, 3).repeat(2),
          )}, ${alpha})`;
        }
        return `rgba(${change(hex.slice(0, 2))}, ${change(hex.slice(2, 4))}, ${change(hex.slice(4, 6))}, ${
          hex.length > 6 ? convertHexToAlpha(hex.slice(6, 8)) : alpha
        })`;
      } else {
        return color.replace(/[\d\.]+\)$/g, `${alpha})`);
      }
    };
    this.init();
  };
  jQuery.fn.gfColorPicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfcolorpicker')) {
        const plugin = new jQuery.gfColorPicker(this, options);
        jQuery(this).data('gfcolorpicker', plugin);
      }
    });
  };
})(jQuery);
